import styled from "styled-components";
import { motion } from "framer-motion";

export const Detalhes = styled(motion.div)`
    min-width: 535px;
    width: calc(75% - 20px);
    height: 230px;
    max-height: 230px;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 15px;

    &[data-segmento="Atividades"] { 
        width: calc(100% - 630px);
    }

    @media (min-width: 1421px) and (max-width: 1480px) {  
        width: calc(50% - 20px);
    }
    @media (max-width: 1420px) {  
        width: calc(100% - 20px);
    }


    p.Detalhamento__title {
        font-weight: 600;
        color: var(--text-color);
        width: 100%;
        font-size: 14px;
        margin: 0;
        padding: 0;
    }

    div.Detalhamento__cards {
        width: 100%;
        display: grid;
        grid-gap: 10px; 
        /* grid-template-columns: repeat(auto-fit, minmax(139px, 1fr)); */
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        margin-top: 5px;
    }
`;